import React, { useState, useEffect } from "react";

// this component is used to make any input component controlled

const ControlledInputWrapper = props => {
  const {
    children,
    value,
    updateInputField,
    name,
    shouldSyncLocalStateWithInput = false,
  } = props;

  const [val, setVal] = useState(value);

  useEffect(() => {
    if (shouldSyncLocalStateWithInput) {
      setVal(value);
    }
  }, [value, shouldSyncLocalStateWithInput]);

  const updateValue = (value, extraParams) => {
    if (name) {
      setVal(value[name]);
    } else {
      setVal(value);
    }

    if (updateInputField) {
      updateInputField(value, extraParams);
    }
  };

  return React.cloneElement(children, {
    value: val,
    updateInputField: updateValue,
  });
};

export default ControlledInputWrapper;
